import React from 'react';
import { Divider } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import type { UseFormReturnType } from '@mantine/form';
import DateTimeUtils from '@dr-pam/common-components/Utils/DateTimeUtils';
import type { KlaviyoTestFormValues } from './KlaviyoTestFormTypes';

export type DateRangeFieldsProps = {
	form: UseFormReturnType<KlaviyoTestFormValues>;
	disabled: boolean;
	/** Overrides the default `getInputProps('validFrom')` onChange so the parent can suggest a
	 *  `validTo` date synchronously when this changes, instead of via an effect. */
	onValidFromChange: (value: Date | null) => void;
};

export default function DateRangeFields(props: DateRangeFieldsProps) {
	const { form, disabled, onValidFromChange } = props;

	return (
		<>
			<Divider label="Dates" />
			<DateInput
				{...form.getInputProps('validFrom')}
				onChange={(value) => onValidFromChange(value ? DateTimeUtils.parse(value) : null)}
				dateParser={DateTimeUtils.parse}
				label="Valid from"
				description="(DD-MM-YYYY)"
				valueFormat="DD-MM-YYYY"
				popoverProps={{ withinPortal: true }}
				disabled={disabled}
				withAsterisk
				clearable
			/>
			<DateInput
				{...form.getInputProps('validTo')}
				dateParser={DateTimeUtils.parse}
				label="Valid to"
				description="(DD-MM-YYYY), the date this event's date-math is measured against"
				valueFormat="DD-MM-YYYY"
				popoverProps={{ withinPortal: true }}
				disabled={disabled}
				withAsterisk
				clearable
			/>
		</>
	);
}
